<template>
        <v-btn
            @click="handleClick"
            :color="btnColor(value)"
            :text="frmttdText(value) || '—'"
            variant="flat"
            size="small"
            class="font-weight-bold"
            ></v-btn>
</template>

<script>
  import { isNone } from "@/functions.js";

  export default {
    props: {
      value: {
        type: String,
        required: false,
      },
      limit_orange: {type: Number, required: false, default: 6},
      limit_red: {type: Number, required: false, default: 12},
    },
    computed: {
      limit_red_date() {
        let ref = new Date()
        ref.setMonth(ref.getMonth() - this.limit_red)
        return ref
      },
      limit_orange_date() {
        let ref = new Date()
        ref.setMonth(ref.getMonth() - this.limit_orange)
        return ref
      },
    },
    methods: {
      frmttdText (value) {
        if (isNone(value)) return value
        return this.$filters.formatDate(value.substring(0,10));
      },
      btnColor (item){
        if (item == undefined || item =='') return 'grey-lighten-1'
        let refDate = new Date(item.substring(0,10))
        if (refDate <= this.limit_red_date) return 'red-darken-1'
        if (refDate <= this.limit_orange_date) return 'orange-darken-1'
        return 'green-darken-1'
      },
      handleClick(){
        this.$emit('click');
      },
    },
  };
</script>
